import logo from '../assets/premier_page_img/logo.png';
import logo_fida from '../assets/premier_page_img/logo_fida.png';
import partenaire1 from '../assets/premier_page_img/1.webp';
import partenaire2 from '../assets/premier_page_img/2.webp';    
import partenaire3 from '../assets/premier_page_img/3.webp';
import partenaire4 from '../assets/premier_page_img/4.webp';
import partenaire5 from '../assets/premier_page_img/5.webp';
import partenaire6 from '../assets/premier_page_img/6.webp';
import partenaire7 from '../assets/premier_page_img/7.webp';
import armoirie from '../assets/premier_page_img/armoirie_du_tchad.webp';
import renfort from '../assets/premier_page_img/renfort.webp';
import bg1 from '../assets/premier_page_img/bg1.svg';

export default {

    logo,
    logo_fida,
    bg1,
    partenaire1,
    partenaire2,
    partenaire3,
    partenaire4,
    partenaire5,
    partenaire6,
    partenaire7,
    armoirie,
    renfort,
    

} 


